
import request from '../request'

export function fetchList(params) {
    return request({
        url: '/user-service/user/face/list',
        params
    })
}